export function doOpenUrlForIE(targetUrl, options) {
  var replace = options.replace,
      windowFeatures = options.windowFeatures,
      windowName = options.windowName; // 因为 IE 不需要考虑多线程卡顿问题，就单独拎出来了

  if (replace) {
    window.location.href = targetUrl;
  } else {
    window.open(targetUrl, windowName, windowFeatures);
  }
}